import { render, staticRenderFns } from "./vipExclusive.vue?vue&type=template&id=64bfe727&scoped=true&"
import script from "./vipExclusive.vue?vue&type=script&lang=js&"
export * from "./vipExclusive.vue?vue&type=script&lang=js&"
import style0 from "./vipExclusive.vue?vue&type=style&index=0&id=64bfe727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bfe727",
  null
  
)

export default component.exports